import { IGuestApi } from "../../../infrastructure/apis/guest";
import { EventDTO, EventRequestDTO, GuestEventPost, JoinEventGuest } from "../../../infrastructure/dtos/guest";
import { GuestDetails, StorageMomentGuestDetails } from "../../../infrastructure/dtos/types/storage";
import { getStorage, setStorage } from "../../../infrastructure/storage";
import { type IGuestService } from "./IGuestService";

export class GuestService implements IGuestService {
    constructor(readonly guestApi: IGuestApi) {
    }

    public async event(eventRequestDTO: EventRequestDTO): Promise<EventDTO> {
        return await this.guestApi.event(eventRequestDTO);
    }

    public async joinGuest(name: string, moment: string): Promise<JoinEventGuest> {
        const response = await this.guestApi.joinEvent({name, moment});
        return response
    }

    public async post(paylaod: GuestEventPost){
        return await this.guestApi.post(paylaod);
    }

    public guest(moment: string): StorageMomentGuestDetails | null{
        const data = getStorage(moment)
        if(typeof data === 'string')
            return JSON.parse(data);
        return null;
    }
    public async setGuest(data: GuestDetails, token: string,moment: string): Promise<void> {
        if(data) {
            setStorage(moment, {
                data,
                token,
                moment
            })
        }
    }
}